import React, { useEffect, useState } from "react";
import "../../css/methods/Description.css";

import Image from "react-image-webp";

import image1 from "../../images/study-method/description1.jpeg";
import imageWebp1 from "../../images/study-method/description1.webp";

import image2 from "../../images/study-method/descripcion2.jpeg";
import imageWebp2 from "../../images/study-method/descripcion2.webp";

import {
    IoBulbOutline,
    IoPaperPlaneOutline,
    IoCogOutline,
    IoSchoolOutline,
} from "react-icons/io5";

const Description = () => {
    const [active, setActive] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setActive(true);
        }, 100);
    }, [active]);

    const handleLink = (e) => {
        e.preventDefault();
        const target = e.target.getAttribute("href");
        const location = document.querySelector(target).offsetTop;
        window.scrollTo({
            left: 0,
            top: location - 80,
        });
    };

    return (
        <div
            className="Description"
            style={active ? { opacity: 1 } : { opacity: 0 }}
        >
            <div className="description-content">
                <div className="description-content-header">
                    <h2 className="description-content-title">
                        Crea personajes para videojuegos 
                    </h2>
                    <div className="description-content-separator"></div>
                </div>
                <p>
                Crearemos desde cero un personaje para videojuegos usando ZBrush, Maya, Substance Painter y Unreal Engine 5.
                </p>
                <ul>
                    <li>
                        <IoBulbOutline className="description-icon" />
                        Incluye cursos de diferentes niveles
                    </li>
                    <li>
                        <IoPaperPlaneOutline className="description-icon" />
                        Se lleva una curva de aprendizaje guiada
                    </li>
                    <li>
                        <IoCogOutline className="description-icon" />
                        Se usan softwares complementarios
                    </li>
                    <li>
                        <IoSchoolOutline className="description-icon" />
                        El objetivo es llevarte a un nivel intermedio avanzado en ZBrush.
                    </li>
                </ul>
                <a
                    href="https://drive.google.com/file/d/1ojvO3tlLU7XCCHdh4VXPgW2LMGa27Arm/view"
                    className="button-description"
                    target={"_blank"}
                    rel="noreferrer"
                >
                    Ver Temario
                </a>
            </div>
            <div className="description-images-container">
                <div className="description-image image-description-up">
                    <Image src={image1} webp={imageWebp1} />
                </div>
                <div className="description-image image-description-down">
                    <Image src={image2} webp={imageWebp2} />
                </div>
            </div>
        </div>
    );
};

export default Description;
